module.exports = __webpack_public_path__ + "img/09.32759bf1.png";